// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import ViewForeignPepReportPage from '../../components/PEP/ViewForeignReport';
interface IViewReport {
    id: string
}
const ViewPepReport: React.FC<IViewReport> = ({
    id
}) => {
    return (
        <Entrypoint>
            <ViewForeignPepReportPage id={id} />
        </Entrypoint>
    );
}

export default ViewPepReport;